export enum KeyIndicatorsTabItemType {
  SpendLessThanYouMake = 'spendLessThanYouMake',
  PayBillsOnTime = 'payBillsOnTime',
  SaveEnoughToLiveOn = 'saveEnoughToLiveOn',
  MaintainEmergencySavings = 'maintainEmergencySavings',
  HaveManageableDebt = 'haveManageableDebt',
  HaveAGoodCreditScore = 'haveAGoodCreditScore',
}

export const CALCULATING_ANIMATION_URL =
  'https://content.moneydesktop.com/storage/MD_Assets/serenity/loading_animation_final.gif'
